import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cm',
  templateUrl: './cm.component.html',
  styleUrls: ['./cm.component.scss']
})
export class CmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
